import {
  fetchCompanies,
  fetchForSuppliersCompanies,
} from "../services/company.service";

export const getCompaniesList = async (payload, set) => {
  try {
    set({ isCompaniesListLoading: true });
    const response = await fetchCompanies(payload);

    if (response?.data?.isSuccess) {
      set({
        companiesList: response?.data?.body?.data,
        pagination: {
          limit: response?.data?.body?.limit,
          page: response?.data?.body?.page,
          totalCount: response?.data?.body?.total,
        },
      }); // Save quote list to state
    } else {
      //   createAlert({
      //     type: "error",
      //     title: "Error fetching user",
      //     message: response.data.message || "Failed to fetch user",
      //     status: true,
      //   });
      set({
        list: [],
        pagination: { limit: 10, page: 1, totalCount: 0, totalPages: 0 },
      });
    }
  } catch (error) {
    console.error("Error fetching user:", error);
    // createAlert({
    //   type: "error",
    //   title: "Error",
    //   message: "An error occurred while fetching user.",
    //   status: true,
    // });
  } finally {
    set({ isCompaniesListLoading: false });
  }
};

export const getInviteOnlyCompaniesList = async (payload, set) => {
  try {
    set({ isInviteOnlyCompaniesListLoading: true });
    const response = await fetchForSuppliersCompanies(payload);
    if (response?.data?.isSuccess) {
      set({
        forInviteOnlyCompaniesList: response?.data?.body?.data,
        pagination: {
          limit: response?.data?.body?.limit,
          page: response?.data?.body?.page,
          totalCount: response?.data?.body?.total,
        },
      }); // Save quote list to state
    } else {
      //   createAlert({
      //     type: "error",
      //     title: "Error fetching user",
      //     message: response.data.message || "Failed to fetch user",
      //     status: true,
      //   });
      set({
        forInviteOnlyCompaniesList: [],
        pagination: { limit: 10, page: 1, totalCount: 0, totalPages: 0 },
      });
    }
  } catch (error) {
    console.error("Error fetching user:", error);
    // createAlert({
    //   type: "error",
    //   title: "Error",
    //   message: "An error occurred while fetching user.",
    //   status: true,
    // });
  } finally {
    set({ isInviteOnlyCompaniesListLoading: false });
  }
};
